module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921061149_T.18afedbf.jpg";